/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-11-18 08:46:07
 * @LastEditors: jyf
 * @LastEditTime: 2022-12-08 08:36:55
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace ShipManagementApi {
    /**
    *  获取发货方列表
    */
    export var GetList = (body: type.GetShipperListPayload): Promise<any> => {
        return Get(`/msls/Shipper/GetList?${qs.stringify(body)}`, {});
    };
    /**
    * 获取发货方详情
    */
    export var GetDetail = (id: string): Promise<type.ShipperDetailVM> => {
        return Get(`/msls/Shipper/GetDetail/${id}`, {});
    };
    /**
     * 新增发货方
     */
    export var Add = (body: type.AddOrEditShipperVM): Promise<any> => {
        return Post(`/msls/Shipper/Add`, body);
    };
    /**
     * 编辑发货方
     */
    export var Edit = (id: string,body:type.AddOrEditShipperVM): Promise<any> => {
        return Post(`/msls/Shipper/Edit/${id}`,body);
    };
    /**
     * 删除发货方
     */
    export var Delete = (id: string): Promise<any> => {
        return Put(`/msls/Shipper/Delete/${id}`,{});
    };
    /**
     * 获取发货方列表下拉
     */
    export var GetDropDownList = (data): Promise<any> => {
        return Get(`/msls/Shipper/GetDropDownList`, data);
    };
    /**
    * 获取发货方维护的下属车队
    */
    export var GetSettleUserDetail = (shipperId: string): Promise<any> => {
        return Get(`/msls/Shipper/GetCarrierByShipper/${shipperId}`, {});
    };
        /**
         * 车队关联发货方
         */
         export var GetShipperByCarrier = (carrierId: string): Promise<any> => {
            return Get(`/msls/Carrier/GetCustomerBaseByCarrier/${carrierId}`, {});
        };
}